// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@vanmeter/App/SharedStyles/CartLineSharedStyles";
import { orderLinesListStyles } from "@vanmeter/Overrides/Components/OrderLinesList";
import { avoidBreakInsidePrintElement, color, mergeWithCss, priceRequireQuoteMessage, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

orderLinesListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

orderLinesListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

orderLinesListStyles.productImageLink = {
    ...cartLineSharedStyles.productImage?.linkWrappingImage,
};

orderLinesListStyles.orderLineCardImage = {
    height: "96px",
    width: "96px",
};

orderLinesListStyles.productInfoSubtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.subtotalWithoutVatHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.priceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.addToListLink = {
    ...cartLineSharedStyles.addToListLink,
};

orderLinesListStyles.lableText = {
    ...mergeWithCss(cartLineSharedStyles.qtyLabel, {
        css: css`
            ${xScreen("gt", "md")} {
                display: block;
            }
        `,
    }),
};

orderLinesListStyles.readOnlyNotesText = {
    wrapper: {
        css: css`
            margin-top: 5px;
        `,
    },
};

orderLinesListStyles.qtyOrderedField = {
    valueText: {
        css: css`
            margin-bottom: 12px;
        `,
    },
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
};

orderLinesListStyles.qtyShippedField = {
    qtyLabel: {
        css: css`
            display: block;
        `,
    },
};

orderLinesListStyles.productInfoSectionOptionsLableText = {
    ...cartLineSharedStyles.configurationOptionLabel,
};

orderLinesListStyles.productInfoSectionOptionsValueText = {
    ...cartLineSharedStyles.configurationOptionText,
};

orderLinesListStyles.promotionNameLabel = {
    ...cartLineSharedStyles.promotionNameLabel,
};

orderLinesListStyles.orderLineInfoPromotionText = {
    ...cartLineSharedStyles.promotionNameText,
};

orderLinesListStyles.productQtyContainer = {
    css: css`
        @media print {
            display: table;
            content: "";
            clear: both;
            width: 100%;
            max-width: 250px;
            > div:first-child {
                float: left;
                padding-right: 40px;
            }
        }
    `,
};

orderLinesListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

orderLinesListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

orderLinesListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            margin-left: 4px;
        `,
    }),
};

orderLinesListStyles.productOrderPriceContainer = {
    css: css`
        @media print {
            display: block;
            margin-left: 24px;
        }
    `,
};

orderLinesListStyles.gridContainer = {
    css: css`
        padding-top: 24px;
        margin-top: 24px;
        border-top: 1px solid ${color("common.border")};
        ${avoidBreakInsidePrintElement}
    `,
};

orderLinesListStyles.cartLineContainerStyles = {
    container: {
        css: css`
            grid-template-columns: 96px minmax(150px, 1fr) minmax(0, 184px) minmax(0, 137px) minmax(0, 184px) minmax(
                    50px,
                    70px
                );

            ${xScreen("lte", "lg")} {
                grid-template-columns:
                    96px minmax(150px, 1fr) minmax(0, 154px) minmax(0, 125px) minmax(0, 154px)
                    minmax(50px, 70px);
            }

            ${xScreen("lte", "md")} {
                grid-template-columns: 96px minmax(0px, 1fr) minmax(0px, 1fr) minmax(50px, 70px);
            }
            @media print {
                margin-bottom: 1px;
            }
            ${avoidBreakInsidePrintElement}
        `,
    },
    remove: {
        css: css`
            padding: 0;
            ${xScreen("lte", "md")} {
                grid-column: 6 / 7;
            }
        `,
    },
    qty: {
        css: css`
            @media print {
                display: block;
                margin-left: 24px;
            }
        `,
    },
};

orderLinesListStyles.linesHeader = {
    wrapper: {
        css: css`
            grid-template-columns: 96px minmax(150px, 1fr) minmax(0, 184px) minmax(0, 137px) minmax(0, 184px) minmax(
                    50px,
                    70px
                );
            ${xScreen("lte", "lg")} {
                grid-template-columns:
                    96px minmax(150px, 1fr) minmax(0, 154px) minmax(0, 114px) minmax(0, 154px)
                    minmax(50px, 70px);
            }
        `,
    },
};

orderLinesListStyles.quoteText = {
    ...priceRequireQuoteMessage
};

orderLinesListStyles.extendedUnitNetPriceHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
